import { useState, useEffect } from "react";
import { Button, Modal } from "@/components/kit";
import { Icon } from "@/lib/icons";

// Shared destructive-action gate: asks plainly, then requires typing "delete".
export default function ConfirmDelete({ open, onClose, onConfirm, title, message, confirmLabel = "Delete" }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setText(""); setBusy(false); } }, [open]);
  if (!open) return null;
  const armed = text.trim().toLowerCase() === "delete";
  const go = async () => {
    if (!armed || busy) return;
    setBusy(true);
    try { await onConfirm(); } finally { setBusy(false); onClose(); }
  };
  return (
    <Modal open onClose={onClose} title={title || "Are you sure?"} data-testid="confirm-delete"
      footer={<>
        <Button variant="secondary" onClick={onClose} data-testid="confirm-delete-cancel">Cancel</Button>
        <Button variant="danger" onClick={go} disabled={!armed || busy} data-testid="confirm-delete-go">{busy ? "Deleting…" : confirmLabel}</Button>
      </>}>
      <div className="flex items-start gap-3 mb-4">
        <div className="w-9 h-9 rounded-full bg-maroon/10 text-maroon flex items-center justify-center shrink-0"><Icon name="Trash2" className="w-5 h-5" /></div>
        <p className="text-[15px] text-ink/80">{message || "This moves the record to Trash, where it can be restored for 30 days before it is permanently removed."}</p>
      </div>
      <label className="block text-[13px] font-semibold text-ink/70 mb-1">Type <span className="text-maroon">delete</span> to confirm</label>
      <input data-testid="confirm-delete-input" value={text} onChange={(e) => setText(e.target.value)} autoFocus
        onKeyDown={(e) => e.key === "Enter" && go()}
        placeholder="delete"
        className="w-full bg-warm-cream border border-ink/20 rounded-lg px-3 py-2.5 min-h-[44px] text-[15px] focus:outline-none focus:border-maroon/60" />
    </Modal>
  );
}
